import PropTypes from 'prop-types';

import { theme } from '@prose-ui';
import { legacyTheme, styled } from '@prose-ui/legacy';
import MarkdownIt from 'markdown-it';

import ProgressLine from 'Components/ProgressLine';

import { scroringModalScoreLabel } from 'assets/content/prescription/content';

const ScoringContentOutter = styled('div')`
  border-bottom: ${props =>
    props.isActive ? `solid 1px ${theme.colors.tertiary['200']}` : 'none'};
  width: 100%;
  margin-top: ${props => (props.isActive ? '30px' : '0')};
  height: ${props => (props.isActive ? 'auto' : '0')};
  visibility: ${props => (props.isActive ? 'visible' : 'hidden')};
  transition:
    height 0.2s,
    margin 0.2s ease-in;
`;
const ScoringContentInner = styled('div')`
  width: 280px;
  margin: 0 auto;
  color: ${theme.colors.primary[400]};
  font-size: 0.875rem; // 14px
  font-family: ${legacyTheme.typography.simplonNorm};

  ${legacyTheme.breakpoints.up('sm')} {
    width: 558px;
  }
`;

const MinMaxLine = styled('div')`
  display: flex;
  justify-content: space-between;
  font-size: 0.75rem; // 12px
  p {
    margin: 0;
    letter-spacing: 0.5px;
  }
`;

const ScoreResultSubtitle = styled('div')`
  text-transform: uppercase;
  font-size: 0.74rem; // 13px
  margin-bottom: 15px;
  font-family: ${legacyTheme.typography.simplonMono};
  font-weight: 600;
  color: ${theme.colors.primary[400]};
`;

const StyledKeyQuestions = styled.div`
  p,
  ul {
    margin: 0;
    letter-spacing: 0.5px;
  }

  li {
    margin-left: -26px;
  }
  margin-bottom: 30px;
`;

const StyledGoalDescription = styled.div`
  p {
    margin: 20px 0;
    letter-spacing: 0.5px;
  }
`;

const ScoringListContentMobile = ({ goal, isActive }) => {
  const md = new MarkdownIt();

  return (
    <ScoringContentOutter isActive={isActive}>
      <ScoringContentInner>
        <ScoreResultSubtitle>{scroringModalScoreLabel(goal.name, goal.value)}</ScoreResultSubtitle>
        <ProgressLine
          backgroundColor={theme.colors.primary[100]}
          color={theme.colors.primary[300]}
          height="8px"
          progress={goal.value ?? 0}
        />
        <MinMaxLine>
          <p>{goal.minLabel}</p>
          <p>{goal.maxLabel}</p>
        </MinMaxLine>
        <StyledGoalDescription
          dangerouslySetInnerHTML={{ __html: md.render(goal.description || '') }}
        />
        <StyledKeyQuestions
          dangerouslySetInnerHTML={{ __html: md.render(goal.keyQuestions || '') }}
        />
      </ScoringContentInner>
    </ScoringContentOutter>
  );
};

ScoringListContentMobile.propTypes = {
  goal: PropTypes.shape({
    value: PropTypes.number,
    name: PropTypes.string,
    minLabel: PropTypes.string,
    maxLabel: PropTypes.string,
    description: PropTypes.string,
    keyQuestions: PropTypes.string,
  }).isRequired,
  isActive: PropTypes.bool.isRequired,
};

export default ScoringListContentMobile;
